import type { ReactNode } from "react";
import { useEffect } from "react";

import { useAudioCoordinator } from "../stores/audioCoordinator";
import styles from "../styles/App.module.css";
import { GlobalControls } from "./GlobalControls";

type PageShellProps = {
  title: string;
  where: string;
  children: ReactNode;
};

export function PageShell({ title, where, children }: PageShellProps) {
  const message = useAudioCoordinator((state) => state.message);

  useEffect(() => {
    document.title = `${title} - 我的听戏`;
  }, [title]);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <p className={styles.eyebrow}>我的听戏</p>
        <h1>{title}</h1>
      </header>
      <main className={styles.main}>{children}</main>
      <p className={styles.liveRegion} aria-live="assertive">
        {message}
      </p>
      <GlobalControls where={where} />
    </div>
  );
}
